import React, { useContext, useEffect, useState } from 'react';
import Select from "react-select";
import { Icon } from '@iconify/react';
import { ToastContainer, toast } from 'react-toastify'
import { AddSessionApi, CalendarOfSittingsAdd, GetConstituency, GetConstituencyMaped, GetKlaListForSearchFilter, GetMemberList, GetMemberMappingList, GetRole, GetSalutation, MemberMappinAdd } from '../../Services/allApi';
import DatePicker from 'react-datepicker';
import { addcontext } from '../../ContextShare/ContextShare';
import PopOver from '../../Components/PopOver';
import InfoIcon from '../../Components/InfoIcon'

// Custom option component
const CustomOption = (props) => {
    const { innerRef, innerProps, data } = props;
    const parts = data.label.split(" ");
    const constituency = parts[0];
    const coNo = parts[1];
    const reserved = parts[2]
    const desc = parts[3]


    return (
        <div ref={innerRef} {...innerProps} className="custom-option">
            <div className="flex flex-row gap-2 w-full border border-blue-gray-300 bg-gray-100 mb-2 hover:bg-gray-300 cursor-pointer ">
                <div className="w-4/12 flex-1 flex p-1 border-r border-gray-300">{constituency}</div>
                <div className=" p-1 border-r border-gray-300 w-6 ">{coNo}</div>
                <div className=" p-1 border-r border-gray-300 w-2/12">{reserved}</div>
                <div className=" p-1 items-start justify-start flex flex-col w-5/12  ">{desc}</div>
            </div>
        </div>
    );
};

// Custom styles for the select component
const customStyles = {
    container: (provided) => ({
        ...provided,
        width: '100%',
    }),
    menu: (provided) => ({
        ...provided,
        width: '1000px',
    }),
    option: (provided, state) => ({
        ...provided,
        padding: '5px 10px',
    }),
    control: (baseStyles, state) => ({
        ...baseStyles,
        borderColor: state.isFocused ? '#384D6C' : '#384D6C',
        height: '2rem',
        borderRadius: '0.5rem',
    }),
};
function AddNewSession() {

    const { addSession, setAddSession } = useContext(addcontext)

    const [currentStep, setCurrentStep] = useState(1);
    const [completedSteps, setCompletedSteps] = useState([]);
    const [videoDetailsArray, setVideoDetailsArray] = useState([]);
    const [sessionList, setSessionList] = useState([])
    const [klaList, setKlaList] = useState([])
    const [memberList, setMemberList] = useState([])
    const [constituencyList, setconstituencyList] = useState([])
    const [saluationtList, setSaluationtList] = useState([])
    const [roleList, setRoleList] = useState([])
    const [klaId, setKlaId] = useState()
    const [inputType, setinputType] = useState('text')
    const [VideoInitialDetails, setVideoInitialDetails] = useState({
        startDate: null,
        endDate: null,
        kla: null,
        video_session: null,
    });

    const [SessionIdAfterConnected, setSessionIdAfterConnected] = useState('')
    // member mapping logic starts
    const [formData, setFormData] = useState({
        member: null,
        constituency: null,
        salutation: null,
        role: null,
        designation: '',
        mal_designation: '',
        session: SessionIdAfterConnected

    });

    const [formList, setFormList] = useState([]);

    const handleInputChangeMM = (field, value) => {
        setFormData({
            ...formData,
            [field]: value
        });
    };

    const handleAddForm = () => {
        if (formData.member && formData.constituency && formData.designation && formData.role && formData.salutation) {
            setFormList([formData,...formList]);
            setFormData({
                member: null,
                constituency: null,
                salutation: null,
                role: null,
                designation: '',
                mal_designation: '',
                session: SessionIdAfterConnected
            });
        }
        else {
            toast.warning("Fill the form completely to add")
        }

    };

    const handleInputChangeList = (index, field, value) => {
        const newFormList = [...formList];
        newFormList[index][field] = value;
        setFormList(newFormList);
    };

    const handleRemoveForm = (index) => {
        const newFormList = formList.filter((_, i) => i !== index);
        setFormList(newFormList);
    };

    const handleSubmitMM = async () => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        // console.log(JSON.stringify(formList, null, 2));
        console.log(JSON.stringify(formList, null, 2));

        const modifiedFormList = formList?.map(item => ({
            member: item.member.value,
            constituency: item.constituency.value,
            salutation: item.salutation.value,
            role: item.role.value,
            designation: item.designation,
            mal_designation: item.mal_designation,
            session: SessionIdAfterConnected
        }));

        console.log(JSON.stringify(modifiedFormList, null, 2));


        const res = await MemberMappinAdd(modifiedFormList, reqHeader)
        console.log(res);
        if (res?.data?.code == 200) {
            handleNextStep(3)
            toast.success("Member added successfully")
        }
        else {
            const errs = res?.response?.data?.errors;
            if (Array.isArray(errs) && errs.length > 0) {
                toast.warning(errs.map(e => e?.error || JSON.stringify(e)).join('; '))
            } else {
                toast.warning(`${res?.response?.data?.message}`)
            }
        }

    }

    // member mapping ends

    // sittings logic starts
    const [currentEntry, setCurrentEntry] = useState({
        startDate: null,
        description: '',
        malayalam_description: ''
    });

    const [entryList, setEntryList] = useState([]);

    const handleInputChangeSittings = (field, value) => {
        setCurrentEntry({
            ...currentEntry,
            [field]: value
        });
    };

    const handleAddEntry = () => {
        if (currentEntry.startDate && currentEntry.description) {
            setEntryList([...entryList, currentEntry]);
            setCurrentEntry({
                startDate: '',
                description: '',
                malayalam_description: ''
            });
        }

        else {
            toast.warning("Fill the from completely to add")
        }

    };

    const handleInputChangeListSittings = (index, field, value) => {
        const newEntryList = [...entryList];
        newEntryList[index][field] = value;
        setEntryList(newEntryList);
    };

    const handleRemoveEntry = (index) => {
        const newEntryList = entryList.filter((_, i) => i !== index);
        setEntryList(newEntryList);
    };

    const handleSubmit = async () => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        console.log('Submitted Entries:', entryList);

        const modifiedSittingsList = entryList?.map(item => ({
            sitting_date: item.startDate,
            description: item.description,
            malayalam_description: item.malayalam_description,
            session: SessionIdAfterConnected
        }));

        console.log(JSON.stringify(modifiedSittingsList, null, 2));

        const res = await CalendarOfSittingsAdd(modifiedSittingsList, reqHeader)
        console.log(res);
        if (res?.data?.code == 200) {
            toast.success("sittings added successfully")
            setAddSession(false)
        }
        else {
            toast.warning(`${res?.response?.data?.message}`)
        }
        // setAddSession(false)
        // Add your submit logic here
    };
    // siitng logic ends


    const handleNextStep = (step) => {
        setCompletedSteps([...completedSteps, currentStep]);
        setCurrentStep(step);
    };


    // const handleInputChange = (index, field, value) => {
    //     const updatedVideos = [...videoDetailsArray];
    //     updatedVideos[index][field] = value;
    //     setVideoDetailsArray(updatedVideos);
    // };

    const isStepCompleted = (step) => completedSteps.includes(step);

    const stepperStyle = (step) => ({
        backgroundColor: currentStep === step || isStepCompleted(step) ? '#009f6b' : '#dcdcdc',
        color: currentStep === step || isStepCompleted(step) ? '#fff' : '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '3rem',
        height: '3rem',
        borderRadius: '50%',
        margin: '1rem 0',
        fontSize: '1.2rem',
        cursor: 'pointer',
    });

    const klaListCallApi = async () => {
        try {
            const result = await GetKlaListForSearchFilter();
            // console.log(result);
            setKlaList(result?.data?.data)
            // console.log(klaList);
            // console.log(result?.data?.results);
            // setGetBsListData(result?.data?.results)

        } catch (error) {
            console.error("Error fetching Kla list for filter:", error);
        }
    }

    useEffect(() => {
        klaListCallApi();
    }, []);


    // Define klaoptions outside useEffect
    const [klaoptions, setKlaOptions] = useState([]);


    useEffect(() => {
        if (klaList?.length > 0) {
            const options = klaList.map(item => ({
                value: item.kla_id,
                label: `KLA${item.kla_no}`,
                valueApi: item.kla_id
            }));
            setKlaOptions(options);

            const latestKLA = options.reduce((maxKLA, currentKLA) => {
                return currentKLA.value > maxKLA.value ? currentKLA : maxKLA;
            }, options[0]); // Initialize with the first KLA option

            setVideoInitialDetails(prevState => ({
                ...prevState,
                kla: latestKLA
            }));
        }
    }, [klaList]);

    // get Member list
    const MemberListCallApi = async () => {
        // console.log(VideoInitialDetails?.video_session?.value);
        try {
            const resultMember = await GetMemberList();
            // console.log(resultMember);
            setMemberList(resultMember?.data?.data)
        } catch (error) {
            console.error("Error fetching Member list for filter:", error);
        }
    }


    useEffect(() => {
        MemberListCallApi();
    }, []);

    // member dropdown
    const memberoptions = memberList?.map((item, index) => ({
        value: item.member_id,
        label: `${item.member_name}`,
        valuefrosearch: item.member_id

    }));


    // get salutation list
    const SalutationListApi = async () => {
        // console.log(VideoInitialDetails?.video_session?.value);
        try {
            const resultsalute = await GetSalutation();
            // console.log(resultsalute);
            setSaluationtList(resultsalute?.data?.data)
        } catch (error) {
            console.error("Error fetching salutation list :", error);
        }
    }


    useEffect(() => {
        SalutationListApi();
    }, []);

    // salutation dropdown
    const saluteoptions = saluationtList?.map((item, index) => ({
        value: item.id,
        label: `${item.salutation_name}`,
        valuefrosearch: item.id

    }));


    // get role list
    const RoleListApi = async () => {
        // console.log(VideoInitialDetails?.video_session?.value);
        try {
            const resultrole = await GetRole();
            // console.log(resultrole);
            setRoleList(resultrole?.data?.data)
        } catch (error) {
            console.error("Error fetching role list :", error);
        }
    }


    useEffect(() => {
        RoleListApi();
    }, []);

    // salutation dropdown
    const roleoptions = roleList?.map((item, index) => ({
        value: item.role_id,
        label: `${item.role_name}`,
        valuefrosearch: item.role_id

    }));

    const handleNextAFterPhaseOne = async () => {
        if (VideoInitialDetails.kla && VideoInitialDetails.video_session && VideoInitialDetails.startDate) {
            const dataToApi = {
                session_start_date: VideoInitialDetails?.startDate,
                session_end_date: VideoInitialDetails?.endDate,
                kla: VideoInitialDetails?.kla?.valueApi,
                session_no: Number(VideoInitialDetails?.video_session),
            }
            setKlaId(VideoInitialDetails?.kla?.valueApi)

            // console.log(dataToApi);
            const token = sessionStorage.getItem('access_token')
            const reqHeader = {
                "Content-Type": "application/json",
                "Authorization": `${token}`
            };

            const result = await AddSessionApi(dataToApi, reqHeader)
            console.log((result));
            if (result?.status == '200') {
                toast.success("Session adding successfull")
                setSessionIdAfterConnected(result?.data?.data)
                const sesID = result?.data?.data
                handleNextStep(2)
                memberMappingList(sesID)
                ConstutencyListApi(sesID)
                startNoteTimout()
                // setVideoInitialDetails({
                //     startDate: null,
                //     endDate: null,
                //     kla: null,
                //     video_session: null,
                // })

            }
            else {
                toast.error(result?.response?.data?.message ?? "There wa a problem adding session")
            }
        }
        else {
            toast.warning("Please fill the form")
        }


    }

    // get Constituency list
    const ConstutencyListApi = async (sId) => {
        // console.log(VideoInitialDetails?.video_session?.value);
        try {
            const resultConstituency = await GetConstituencyMaped(sId);
            // console.log(resultConstituency);
            setconstituencyList(resultConstituency?.data?.data)
        } catch (error) {
            console.error("Error fetching constituency list :", error);
        }
    }


    // useEffect(() => {
    //     ConstutencyListApi();
    // }, []);

    // constituency dropdown
    const constituencyOptions = constituencyList?.map((item, index) => ({
        value: item.id,
        label: `${item?.constituency_name} ${item?.constituency_no} ${item?.reservation} ${item?.constituency_description}`,
        valuefrosearch: item.id

    }));
    // useEffect(()=>{
    //     memberMappingList()
    // },[])
    // member mapping list
    const memberMappingList = async (sessId) => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        console.log(SessionIdAfterConnected);
        const res = await GetMemberMappingList(sessId)
        if (res?.data?.data) {
            setFormList(res?.data?.data)
        }
        console.log(res);
    }

    const sessionAddScript = async () => {
        for (var i = 0; i <= 100; i++) {
            const payload = { session_start_date: "2024-08-12", kla: 23, session_no: i + 21 }
            callApiToAddBulk(payload)
        }

    }

    const callApiToAddBulk = async (payload) => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        await AddSessionApi(payload, reqHeader)
    }
    const [isDesgSelected, setIsDesgSelected] = useState('')
    const [isNoteVisible,setisNoteVisible]=useState(true)
    const handleDesgClick = () => {
        setIsDesgSelected('d')
    }
    const handleDesgMalClick = () => {
        setIsDesgSelected('dm')
    }
    const startNoteTimout=()=>{
        setTimeout(()=>{
            setisNoteVisible(false)
        },50000)
    }
    return (
        <>
            <div className='flex w-full h-full flex-row' style={{ height: '86vh' }}>
                <div className='ms-2 mb-10 me-2 flex flex-col w-1/12 justify-start items-center bg-success rounded' style={{ height: '86vh' }}>
                    {[1, 2, 3].map(step => (
                        <div key={step} className='flex flex-col items-center'>
                            <div className='transform duration-1000 ease-in'
                                style={stepperStyle(step)}
                            // onClick={() => handleNextStep(step)}
                            >
                                {isStepCompleted(step) ? (
                                    <Icon icon="ci:circle-check" className='text-2xl ' />
                                ) : (
                                    <span>{step}</span>
                                )}
                            </div>
                            {step < 3 && <div className={`w-1 h-48 transform duration-1000 rounded-full ease-in `} style={{ backgroundColor: `${currentStep >= step ? '#009f6b' : '#dcdcdc'}` }}></div>}
                        </div>
                    ))}
                </div>

                {currentStep === 1 && (
                    <div className='w-full flex items-center flex-col'>
                        {/* <button onClick={sessionAddScript}>execute script</button> */}
                        <h3 className='text-blue-700 text-xl font-bold mt-20 mb-4 text-center'>Enter Session Details</h3>
                        <div className='flex flex-row justify-center flex-wrap mb-10 ms-5 me-5 gap-5 w-full'>

                            <div className='flex flex-col w-2/12 mb-5 mt-5'>
                                <label htmlFor="kla">KLA</label>
                                <Select
                                    id='kla'
                                    options={klaoptions}
                                    value={VideoInitialDetails.kla}
                                    onChange={option => setVideoInitialDetails({ ...VideoInitialDetails, kla: option })}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                            height: '2rem',
                                            borderRadius: '0.3rem',
                                        }),
                                    }}
                                />
                            </div>

                            <div className='w-2/12 flex flex-col  mb-5 mt-5'>
                                <label htmlFor="session">Session No</label>
                                <input
                                    id='session'
                                    type='number'
                                    // options={sessionoptions}
                                    value={VideoInitialDetails.video_session}
                                    onChange={(e) => setVideoInitialDetails({ ...VideoInitialDetails, video_session: e.target.value })}
                                    className='w-full h-10 rounded border border-gray-700 px-2' // Adjusted class

                                />
                            </div>

                            <div className='w-2/12 flex flex-col mb-5 mt-5'>
                                <label htmlFor="sdate">Start Date</label>
                                {/* <div className=' rounded w-10/12' > */}
                                <input
                                    type='date'
                                    // placeholderText="Start Date"
                                    selected={VideoInitialDetails.startDate} // Use selected prop instead of value
                                    onChange={(e) => setVideoInitialDetails({ ...VideoInitialDetails, startDate: e.target.value })}
                                    className='w-full h-10 rounded border border-gray-700 px-2' // Adjusted class
                                    // dateFormat="yyyy-MM-dd" // Set date format if needed
                                    isClearable

                                />
                                {/* </div> */}
                            </div>

                            <div className='w-2/12 flex flex-col mb-5 mt-5'>
                                <label htmlFor="edate">End Date</label>
                                {/* <div className=' rounded w-10/12' > */}
                                <input
                                    type='date'
                                    // placeholderText="End Date"
                                    selected={VideoInitialDetails.endDate} // Use selected prop instead of value
                                    onChange={(e) => setVideoInitialDetails({ ...VideoInitialDetails, endDate: e.target.value })}
                                    className='w-full h-10 rounded border border-gray-700 px-2' // Adjusted class
                                    // dateFormat="yyyy-MM-dd" // Set date format if needed
                                    isClearable

                                />
                                {/* </div> */}
                            </div>

                        </div>
                        <br />
                        <div className='w-2/12'>
                            <button onClick={handleNextAFterPhaseOne} className='w-full py-2 bg-primary text-white rounded-full'>Next</button>
                        </div>
                    </div>
                )}

                {currentStep === 2 && (
                    <div className='w-full flex items-center flex-col overflow-y-scroll overflow-x-hidden' style={{ height: '87vh' }}>
                        <div className='flex flex-row justify-center flex-wrap ms-2 me-2 gap-1 w-full '>
                            <div className='flex flex-col w-full gap-5'>
                                <div className='bg-success px-4 py-2 rounded border'>
                                    <h3 className='text-blue-700 text-xl font-bold mb-4 text-center'>Add Members </h3>

                                    <div className='flex flex-row justify-between flex-wrap mb-5'>

                                        <div className={`flex flex-col ${isDesgSelected == 'd' || isDesgSelected == 'dm' ? 'w-28' : 'min-w-44'}`}>
                                            <label>Constituency</label>
                                            <Select
                                                options={constituencyOptions}
                                                value={formData.constituency}
                                                onChange={option => handleInputChangeMM('constituency', option)}
                                                styles={customStyles}
                                                components={{ Option: CustomOption }}

                                            />
                                        </div>

                                        <div className={`flex flex-col ${isDesgSelected == 'd' || isDesgSelected == 'dm' ? 'w-28' : 'min-w-44'}`}>
                                            <label>Salutation</label>
                                            <Select
                                                options={saluteoptions}
                                                value={formData.salutation}
                                                onChange={option => handleInputChangeMM('salutation', option)}
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                                        height: '2rem',
                                                        borderRadius: '0.5rem',
                                                    }),
                                                }}
                                            />
                                        </div>

                                        <div className={`flex flex-col ${isDesgSelected == 'd' || isDesgSelected == 'dm' ? 'w-28' : 'min-w-44'}`}>
                                            <label>Members</label>
                                            <Select
                                                options={memberoptions}
                                                value={formData.member}
                                                onChange={option => handleInputChangeMM('member', option)}
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                                        height: '2rem',
                                                        borderRadius: '0.5rem',
                                                    }),
                                                }}
                                            />
                                        </div>


                                        <div className={`flex flex-col ${isDesgSelected == 'd' || isDesgSelected == 'dm' ? 'w-28' : 'min-w-44'}`}>
                                            <label>Role</label>
                                            <Select
                                                options={roleoptions}
                                                value={formData.role}
                                                onChange={option => handleInputChangeMM('role', option)}
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                                        height: '2rem',
                                                        borderRadius: '0.5rem',
                                                    }),
                                                }}
                                            />
                                        </div>

                                        <div className={`flex flex-col ${isDesgSelected == 'd' ? 'min-w-96' : isDesgSelected == 'dm' ? 'min-w-20' : 'min-w-44'}`}>
                                            <label className='flex flex-row gap-1 items-center'><span>Designation</span><InfoIcon content={"Enter all designation seperated by , (comma) "} /></label>
                                            <input
                                                type="text"
                                                value={formData.designation}
                                                placeholder="use , to seperate multiple"
                                                onFocus={handleDesgClick}
                                                onBlur={() => setIsDesgSelected('')}
                                                onChange={(e) => handleInputChangeMM('designation', e.target.value)}
                                                className='dateinput w-full h-10 rounded-lg'
                                                style={{ border: '1px solid #384D6C' }}
                                            />
                                        </div>

                                        <div className={`flex flex-col ${isDesgSelected == 'dm' ? 'min-w-96' : isDesgSelected == 'd' ? 'min-w-20 ' : 'min-w-44'}`}>
                                            <label className='flex flex-row gap-1 items-center'><span>Designation Malayalam</span><InfoIcon content={"Enter all designation in malayalam seperated by , (comma) "} /></label>
                                            <input
                                                type="text"
                                                value={formData.mal_designation}
                                                onFocus={handleDesgMalClick}
                                                onBlur={() => setIsDesgSelected('')}
                                                placeholder="use , to seperate multiple"
                                                onChange={(e) => handleInputChangeMM('mal_designation', e.target.value)}
                                                className='dateinput w-full h-10 rounded-lg'
                                                style={{ border: '1px solid #384D6C' }}
                                            />
                                        </div>

                                    </div>
                                    <div className='w-full flex justify-center items-center flex-col'>
                                        {/* note */}
                                        {isNoteVisible&&<div className='flex flex-row justify-end mb-2 '>
                                            <div className='font-bold uppercase '>
                                                <span className='text-blue-700 me-1'>Note: </span> <span className='border py-1 border-yellow-500 text-yellow-900 bg-yellow-100 px-1 rounded-s'>Multiple designations can be entered using a comma separator.</span>
                                            </div>
                                            <button onClick={()=>setisNoteVisible(false)}><span className='hover:bg-red-500 px-2 rounded-e py-1 text-red-500 hover:text-white border-yellow-500 border'>X</span></button>
                                        </div>}
                                        
                                        <div className='w-2/12 '>
                                            <button className='w-full py-2 rounded-full bg-green-500 text-white mb-3' onClick={handleAddForm}>
                                                Add
                                            </button>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='w-full flex flex-col gap-4 mt-4'>
                            {formList?.map((form, index) => (
                                <div key={index} className='bg-gray-200 px-2 rounded border'>
                                    <h3 className='text-gray-700 text-sm text-left'>No {index + 1}</h3>

                                    <div className='flex flex-row justify-between flex-wrap mb-3'>

                                        <div className='flex flex-col min-w-40'>
                                            <label>Constituency</label>
                                            <Select
                                                options={constituencyOptions}
                                                value={form.constituency}
                                                onChange={option => handleInputChangeList(index, 'constituency', option)}
                                                styles={customStyles}
                                                components={{ Option: CustomOption }}
                                            />
                                        </div>

                                        <div className='flex flex-col min-w-40'>
                                            <label>Salutation</label>
                                            <Select
                                                options={saluteoptions}
                                                value={form.salutation}
                                                onChange={option => handleInputChangeList(index, 'salutation', option)}
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                                        height: '2rem',
                                                        borderRadius: '0.5rem',
                                                    }),
                                                }}
                                            />
                                        </div>

                                        <div className='flex flex-col min-w-40'>
                                            <label>Members</label>
                                            <Select
                                                options={memberoptions}
                                                value={form.member}
                                                onChange={option => handleInputChangeList(index, 'member', option)}
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                                        height: '2rem',
                                                        borderRadius: '0.5rem',
                                                    }),
                                                }}
                                            />
                                        </div>



                                        <div className='flex flex-col min-w-40'>
                                            <label>Role</label>
                                            <Select
                                                options={roleoptions}
                                                value={form.role}
                                                onChange={option => handleInputChangeList(index, 'role', option)}
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                                        height: '2rem',
                                                        borderRadius: '0.5rem',
                                                    }),
                                                }}
                                            />
                                        </div>

                                        <div className='flex flex-col min-w-40'>
                                            <label>Designation</label>
                                            <input
                                                type="text"
                                                value={form.designation}
                                                onChange={(e) => handleInputChangeList(index, 'designation', e.target.value)}
                                                className='dateinput w-full h-10 rounded-lg'
                                                style={{ border: '1px solid #384D6C' }}
                                            />
                                        </div>

                                        <div className='flex flex-col min-w-40'>
                                            <label>Designation Malayalam</label>
                                            <input
                                                type="text"
                                                value={form.mal_designation}
                                                onChange={(e) => handleInputChangeList(index, 'mal_designation', e.target.value)}
                                                className='dateinput w-full h-10 rounded-lg'
                                                style={{ border: '1px solid #384D6C' }}
                                            />
                                        </div>


                                        <div className='flex flex-col'>
                                            <label className='' style={{ visibility: 'hidden' }}>Designation</label>
                                            <button className='w-full h-10 rounded-full bg-red-500 text-white ' onClick={() => handleRemoveForm(index)}>
                                                Remove
                                            </button>
                                        </div>


                                    </div>

                                </div>
                            ))}
                        </div>

                        {formList?.length > 0 && <div className='w-2/12'><button className='w-full py-2 mt-20 text-white rounded-full bg-primary' onClick={handleSubmitMM}>Submit</button></div>}

                    </div>
                )}

                {currentStep === 3 && (
                    <div className='w-full flex items-center flex-col overflow-y-scroll overflow-x-hidden' style={{ height: '87vh' }}>
                        <div className='flex flex-row justify-center flex-wrap ms-5 me-5 gap-1 w-full '>
                            <div className='flex flex-col w-full gap-5'>
                                <div className='bg-success px-4 py-2 rounded border'>
                                    <h3 className='text-blue-700 text-xl font-bold mb-4 text-center'>Add Sittings</h3>

                                    <div className='flex flex-row justify-center flex-wrap mb-5'>
                                        <div className='w-3/12 flex flex-col me-5'>
                                            <label htmlFor="sdate">Sitting Date</label>
                                            <input
                                                type='date'
                                                placeholderText="Start Date"
                                                selected={currentEntry.startDate}
                                                onChange={(e) => handleInputChangeSittings('startDate', e.target.value)}
                                                className='w-full h-10 rounded-lg border border-gray-700 px-2'
                                                isClearable
                                            />
                                        </div>

                                        <div className='flex flex-col w-3/12'>
                                            <label>Description</label>
                                            <input
                                                type="text"
                                                value={currentEntry.description}
                                                onChange={(e) => handleInputChangeSittings('description', e.target.value)}
                                                className='dateinput w-full h-10 rounded-lg'
                                                style={{ border: '1px solid #384D6C' }}
                                            />
                                        </div>

                                        <div className='flex flex-col w-3/12'>
                                            <label>Description malayalam</label>
                                            <input
                                                type="text"
                                                value={currentEntry.malayalam_description}
                                                onChange={(e) => handleInputChangeSittings('malayalam_description', e.target.value)}
                                                className='dateinput w-full h-10 rounded-lg'
                                                style={{ border: '1px solid #384D6C' }}
                                            />
                                        </div>

                                        <div className='w-2/12 flex flex-col ms-5'>
                                            <label style={{ visibility: 'hidden' }}>Add</label>
                                            <button className='w-full py-2 rounded-lg bg-green-500 text-white mb-3' onClick={handleAddEntry}>
                                                Add
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='w-full flex flex-col gap-4 mt-4'>
                            {entryList?.map((entry, index) => (
                                <div key={index} className='bg-gray-200 px-4 py-2 rounded border'>
                                    <h3 className='text-gray-700 text-sm text-left'>No {index + 1}</h3>

                                    <div className='flex flex-row justify-center flex-wrap mb-1'>
                                        <div className='w-3/12 flex flex-col me-5'>
                                            <label>Start Date</label>
                                            <input
                                                type='date'
                                                value={entry.startDate}
                                                onChange={(e) => handleInputChangeListSittings(index, 'startDate', e.target.value)}
                                                className='w-full h-10 rounded-lg border border-gray-700 px-2'

                                            />
                                        </div>

                                        <div className='flex flex-col w-3/12'>
                                            <label>Description</label>
                                            <input
                                                type="text"
                                                value={entry.description}
                                                onChange={(e) => handleInputChangeListSittings(index, 'description', e.target.value)}
                                                className='dateinput w-full h-10 rounded-lg'
                                                style={{ border: '1px solid #384D6C' }}
                                            />
                                        </div>

                                        <div className='flex flex-col w-3/12'>
                                            <label>Description malayalam</label>
                                            <input
                                                type="text"
                                                value={entry.malayalam_description}
                                                onChange={(e) => handleInputChangeListSittings(index, 'malayalam_description', e.target.value)}
                                                className='dateinput w-full h-10 rounded-lg'
                                                style={{ border: '1px solid #384D6C' }}
                                            />
                                        </div>

                                        <div className='w-2/12 flex flex-col ms-5'>
                                            <label style={{ visibility: 'hidden' }}>Remove</label>
                                            <button className='w-full py-2 rounded-lg bg-red-500 text-white mb-3' onClick={() => handleRemoveEntry(index)}>
                                                Remove
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {entryList?.length > 0 && (
                            <div className='w-2/12'>
                                <button className='w-full py-2 mt-20 text-white rounded-full bg-primary' onClick={handleSubmit}>
                                    Submit
                                </button>
                            </div>
                        )}
                    </div>
                )}

            </div>

            <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                // pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    );
}

export default AddNewSession;
